<!--
 * @Description: 访客计划 -- 查看页面
 * @Author: mdb
 * @Date: 2022-07-19 11:12:06
 * @LastEditTime: 2022-11-07 16:30:25
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" tab="计划详情">
            <VisitorProgramForm
              ref="visitorProgramFormRef"
              title="访客计划详情"
              v-model:value="dataForm"
              type="view"
              :isEdit="false"
            />
          </a-tab-pane>
          <a-tab-pane key="logs" tab="操作日志">
            <TabsOperationLog appId="cos_fbu" tableId="FbuVisitorOperationLog" :resourceId="route.query.id as string" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <SellerButton
        v-permission="'fbu_visitor_edit_btn'"
        :workCode="dataForm.dutyBy"
        controlType="none"
        v-if="dataForm.status !== 3"
        @click="handleEdit()"
        >编辑</SellerButton
      >
      <SellerButton
        v-permission="'fbu_visitor_complete_btn'"
        :workCode="dataForm.dutyBy"
        controlType="none"
        v-if="dataForm.status !== 3"
        type="primary"
        @click="handleVisitComplete()"
        >完成拜访</SellerButton
      >
    </cos-footer-button>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, reactive, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramDetail } from '@/api/gucangSales/followUpManage'
import type { FbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
const router = useRouter()
const route = useRoute()

const dataForm = reactive<FbuVisitorProgramEditParams>({})

onBeforeMount(() => {
  visitorProgramDetail(route.query.id as string).then((res) => {
    Object.assign(dataForm, res.data)
  })
})

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}

const visitorProgramFormRef = ref()
const handleVisitComplete = (row = dataForm) => {
  router.push({ path: '/fbu/followUpRecord/visitingPlan', query: { planId: row.id } })
}
const handleEdit = () => {
  router.push({ path: '/fbu/visitorProgram/edit', query: { id: route.query.id as string } })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuVisitorProgramView' }
</script>

<style scoped></style>
